export default "__VITE_ASSET__CNaDbvL8__"